import Vue from 'vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

// Buscar última atualização dos dados
/**
 * @param {int} cod_ibge - IBGE do município
 */
export async function getUltimaAtualizacao(cod_ibge) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/ultima-atualizacao-dos-dados/' + cod_ibge
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Buscar data da fonte eSUS PEC
/**
 * @param {int} cod_ibge - IBGE do município
 */
export async function getFonteEsusPec(cod_ibge) {
  try {
    const { data } = await Vue.prototype.$api.get(
      '/app/cadastros-individuais/fonte-esus-pec/' + cod_ibge
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna o nome da cor para pintar a linha da tabela
/**
 *
 */
export function printTableRow(item) {
  return ''
}

export function getRadius(item) {
  let population = item.denominador
  const minRadius = 10
  const maxRadius = 100
  const minPopulation = 0
  const maxPopulation = 10000

  // Ensure that the population is within bounds
  if (population < minPopulation) population = minPopulation
  if (population > maxPopulation) population = maxPopulation

  // Calculate the radius using linear interpolation
  let radius =
    minRadius +
    ((population - minPopulation) / (maxPopulation - minPopulation)) *
      (maxRadius - minRadius)
  return radius
}

export function getRadiusColor(item) {
  let denominador = Number(item.denominador)
  let cadSisab = Number(item.cad_sisab)
  let minCad = Number(item.min_cad)
  let maxCad = Number(item.max_cad)

  if (denominador < minCad) {
    return 'orange'
  } else if (denominador >= minCad && denominador <= maxCad) {
    return 'green'
  } else {
    return 'red'
  }
}

export function getRowColorTabelaPessoasPorEquipe(item) {
  if (Number(item.denominador) < Number(item.min_cad)) {
    return 'orange'
  } else if (
    Number(item.denominador) >= Number(item.min_cad) &&
    Number(item.denominador) <= Number(item.max_cad)
  ) {
    return 'green'
  } else {
    return 'red'
  }
}

export function generatePdf(
  cadastros,
  selectEquipe,
  selectProfissional,
  nomeProfissional,
  data_secretaria_de_saude
) {
  let title_pdf = 'Cadastros cidadãos'
  let titlePdfSave = utils.methods.titlePdf('Cadastros cidadãos')

  let description_pdf = 'Cadastro populacional feito pela eSF e/ou eAP'
  let headers_pdf = [
    'NOME',
    'NASCIMENTO',
    'IDADE',
    'MÃE',
    'MA',
    'ATUALIZADO EM',
    'DOCUMENTO',
    'COMPLETO',
    'CAMPOS DA FCI AINDA NÃO PREENCHIDOS',
  ]
  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    obj.no_cidadao = cadastros[i].no_cidadao
    obj.dt_nascimento = utils.methods.formatDate(cadastros[i].dt_nascimento)
    obj.idade = cadastros[i].idade
    obj.no_mae = cadastros[i].no_mae
    obj.micro_area = cadastros[i].micro_area
    obj.dt_ultima_ficha = utils.methods.formatDate(cadastros[i].dt_ultima_ficha)
    let documentoText = ''
    if (cadastros[i].nu_cpf) {
      documentoText += `CPF ${cadastros[i].nu_cpf}`
    }
    if (cadastros[i].nu_cns) {
      documentoText += `\nCNS ${cadastros[i].nu_cns}`
    }
    obj.documento = documentoText
    obj.completo =
      cadastros[i].percent_fci_completa != null
        ? cadastros[i].percent_fci_completa + '%'
        : ''
    obj.campos_nao_preenchidos = ''
    if (cadastros[i].fci_completa == null) {
      obj.campos_nao_preenchidos =
        'Após o preenchimento da ficha simplificada do cidadão, recomenda-se preencher também a Ficha de Cadastro Individual (FCI) completa. Isso garante a qualidade, completude e integridade do cadastro.'
    } else if (parseInt(cadastros[i].percent_fci_completa) >= 100) {
      obj.campos_nao_preenchidos = 'Parabéns. Este cadastro FCI está completo.'
    } else {
      obj.campos_nao_preenchidos = cadastros[i].fci_completa.replace(
        /^\[|\]$/g,
        ''
      )
    }
    if (cadastros[i].dt_ultima_ficha !== null) {
      obj.dias = utils.methods.differenceOfDaysBetweenTwoDates(
        cadastros[i].dt_ultima_ficha,
        data_secretaria_de_saude.split('/').reverse().join('-')
      )
    } else {
      obj.dias = null
    }
    data_pdf.push(obj)
  }

  let doc = new jsPDF(utils.methods.encryptionPdf())
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )

      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.nu_ine,
          },
          {
            label: 'Total',
            value: cadastros.length,
          },
          {
            label: 'Profissional ACS',
            value: nomeProfissional,
          },
        ],
        verticalPosition
      )

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          let dias = data.row.raw[9]
          let dt_ultima_ficha = data.row.raw[5]
          let percent_fci_completa = data.row.raw[7].replace('%', '').trim()
          if (dt_ultima_ficha == undefined) {
            doc.setTextColor(194, 10, 16) // vermelho
          } else {
            dt_ultima_ficha = dt_ultima_ficha.split('/').reverse().join('-')
            if (
              dias > 366 ||
              dt_ultima_ficha == null ||
              percent_fci_completa === null ||
              Number(percent_fci_completa) < 100
            ) {
              doc.setTextColor(194, 10, 16) // vermelho
            }
            if (
              (parseInt(dias) <= 366 || dt_ultima_ficha !== null) &&
              percent_fci_completa !== null &&
              Number(percent_fci_completa) >= 100
            ) {
              doc.setTextColor(2, 99, 57) // verde
            }
          }
          // pinta a cor da descrição das colunas de preto
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}
